import { PageViewEventLogger, useUserEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import HometaxNoBmanError from '@/components/tax-refund/common/view/ErrorView/HometaxNoBmanError';
import { COMMON_PATHS } from '@/lib/constants/paths';

const ErrorPage = () => {
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  const handleClickOk = () => {
    sendClickEvent('indis-lookup_error-no-bman_ok');
    router.push(COMMON_PATHS.환급조회목록);
  };

  return (
    <AuthGuard>
      <PageViewEventLogger pageName="indis-lookup_error-no-bman" />
      <Layout>
        <HometaxNoBmanError onPrimaryButtonClick={handleClickOk} />
      </Layout>
    </AuthGuard>
  );
};

export default ErrorPage;
